import { EnvironmentProviders, Provider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import {
  HTTP_INTERCEPTORS,
  HttpFeature,
  HttpFeatureKind,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { BdAppConfigResponse } from '@bindoc-projects/app-config-domain-lib';
import { BdAppConfigResponseHelper } from './app-config-response.helper';
import {
  BD_OPPORTUNISTIC_AUTH_CONFIG,
  bdOpportunisticAuthInterceptor,
  createOpportunisticAuthConfig,
} from './opportunistic-auth.interceptor';

export function provideMsalForApp(appConfig: BdAppConfigResponse): Provider[] {
  const msalInstance = BdAppConfigResponseHelper.msalInstance(appConfig);
  const msalGuardConfig = BdAppConfigResponseHelper.msalGuardConfig(appConfig);
  const msalInterceptorConfig =
    BdAppConfigResponseHelper.msalInterceptorConfig(appConfig);

  return [
    { provide: MSAL_INSTANCE, useValue: msalInstance },
    { provide: MSAL_GUARD_CONFIG, useValue: msalGuardConfig },
    { provide: MSAL_INTERCEPTOR_CONFIG, useValue: msalInterceptorConfig },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    // Input for bdOpportunisticAuthInterceptor — derived from the very config
    // MSAL is set up from, so a new backend endpoint never needs a second
    // registration (BDA-5977).
    {
      provide: BD_OPPORTUNISTIC_AUTH_CONFIG,
      useValue: createOpportunisticAuthConfig(appConfig),
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ];
}

export function provideMsalWithHttp(
  appConfig: BdAppConfigResponse,
  ...extraFeatures: HttpFeature<HttpFeatureKind>[]
): Array<Provider | EnvironmentProviders> {
  return [
    ...provideMsalForApp(appConfig),
    provideHttpClient(
      withXhr(),
      // withInterceptorsFromDi() is listed first so MsalInterceptor gets the
      // first look and the opportunistic interceptor can simply skip what it
      // already authorized. The two are safe in either order though — see
      // "Relation to MsalInterceptor" in opportunistic-auth.interceptor.ts.
      withInterceptorsFromDi(),
      withInterceptors([bdOpportunisticAuthInterceptor]),
      ...extraFeatures,
    ),
  ];
}
